import {AfterViewInit, Component, forwardRef, Inject, OnInit, ViewChild} from '@angular/core';
import { StateMap, UnitOfWork, UserManager } from '../../services/common';
import { EditManager, IEditHost, UtilFns } from '../../utils/common';
import { STAFF_ROUTES } from './staff.routes';

import {Material, MaterialComponent, MaterialComposition, MaterialCompositionDescription} from '../../entities/EntityModels';
import {MaterialSelectorComponent} from '../material/material-selector.component';
import {NCSEditData, NCSViewerComponent} from './ncs-viewer.component';

@Component({
    selector: 'ncs-comment-editor',
    templateUrl: './ncs-comment-editor.html',
})
export class NCSCommentEditorComponent implements OnInit, AfterViewInit {

    _edm: EditManager<MaterialCompositionDescription>;

    public _isLoading = false;
    public _pageTitle: string;
    public _validationMessage: string;

    public _parentData: NCSEditData;

    constructor(public _stateMap: StateMap, public _uow: UnitOfWork, public _userManager: UserManager,
                @Inject(forwardRef(() => NCSViewerComponent)) public _parent: NCSViewerComponent) {
        this._parentData = _parent._data;
    }

    ngOnInit() {
        this._edm				= new EditManager<MaterialCompositionDescription>(this, this._uow, this._stateMap, 'NCS Comment Editor');
        this._edm.onlyEntity    = this._parentData.entityComment;
        this._edm.editing       = true;

        this._pageTitle = this.formatPageTitle();
    }

    ngAfterViewInit() {
    }

    formatPageTitle() {
        // tslint:disable-next-line:max-line-length
        const materialData = this._edm.currentEntity.material.principalSynonymText() + ', CAS No.: ' + this._edm.currentEntity.material.realCASNumber + ', RIFM Id: ' + this._edm.currentEntity.material.formattedRIFMId;

        if (this._parentData.deleting) {
            return ('Deleting the NCS Comment for' + materialData);
        }

        return (this._parentData.adding ) ? 'Adding a NCS Comment for ' + materialData : 'Editing the NCS Comment for ' + materialData;
    }

    canDeactivate() {
        return (!this._uow.hasChanges());
    }

    get utilFns() {
        return UtilFns;
    }

    canApply() {
        if (this._edm.editing) {
            return (this._uow.hasChanges() && !this._edm.currentEntity.entityAspect.hasValidationErrors);
        }
        return false;
    }

    canCancel() {
        return this._uow.hasChanges();
    }

    canDelete() {
        return (this._parentData.deleting && !this._parentData.deleteFinished);
    }

    canSave() {
        return this._uow.hasChanges();
    }

    canShowBack() {
        return (!this._uow.hasChanges());
    }

    showSaveButton(): boolean {
        if (this._edm.editing || this._parentData.deleting) { return false; }

        return (this._parentData.adding || this._parentData.editing);
    }

    onApply() {
        if (!this.validateChanges()) {
            return false;
        }

        this._edm.onApplyCore();
    }

    public validateChanges(): boolean {
        this._validationMessage = '';

        if (this.isValidString(this._edm.currentEntity.comments)) {
            return true;
        }

        this._validationMessage = 'Please enter a valid Comment before saving.';
        return false;
    }

    public onBack() {
        this._parentData.adding         		= false;
        this._parentData.deleteFinished 		= false;
        this._parentData.deleting       		= false;
        this._parentData.editing        		= false;
        this._parentData.inCommentSubEditor    	= false;
    }

    public onCancel() {
        this._edm.onCancelCore();

        if (this._parentData.adding) {
            this._parentData.entityComment = null;
        }

        this.onBack();
    }

    onDelete() {
        this._edm.currentEntity.entityAspect.setDeleted();

        this.onSave();
    }

    onSave() {
        return this._edm.onSaveCore().then(() => {
            const materialId = this._edm.currentEntity.materialId;

            this._parentData.adding             = false;
            this._parentData.editing            = false;
            this._parentData.deleteFinished     = true;

            this._validationMessage = (this._parentData.deleting) ? 'Comment removal successful.' : 'Changes were successfully saved.';

            this._parent.fetchMaterialCompositionDescription(materialId);

        }).catch((e) => {
            this._validationMessage = 'An error occurred: ' + e.toString();
        });
    }

    public isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }

}
